import React from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import FormCrearIngreso from './FormCrearIngreso';

import { notification, Modal, Card } from 'antd/lib';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsPedido from '../../../actions/pedido';
import * as actionsMain from '../../../actions/main';

import getIngresos from '../../../graphql/querys/ventas/getIngresos.graphql';
import insertIngreso from '../../../graphql/mutations/venta/insertIngreso.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import _ from 'lodash';

@compose(
  graphql(insertIngreso, {
    name: 'insertIngreso',
    options: {
      refetchQueries: [{ query: getIngresos }],
    },
  }),
  graphql(getUsuario)
)
class CrearIngreso extends React.Component {
  onSubmit = values => {
    values.fechaEnvio = values.fechaEnvio.toDate();
    values.idOrganismoRemitente = this.props.data.getUsuario.organismo._id;
    (values.idPedido = this.props.pedido._id ? this.props.pedido._id : null),
      this.props
        .insertIngreso({
          variables: {
            objIngreso: values,
          },
        })
        .then(res => {
          if (res.data.insertIngreso._id) {
            notification.success({
              message: 'Envio Registrado',
              description:
                'El envio se registró correctamente en la base de datos',
            });
            this.props.actionsPedido.reiniciarPedido();
            this.props.history.push('/');
          }
        })
        .catch(err => {
          console.log('Existio un error a la hora de crear el envio');
          console.log(err);

          Modal.error({
            title: 'Error en la creacion del envio',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
        });
  };

  render() {
    let { pedido } = this.props;
    return (
      <div>
        {pedido._id != '' && (
          <div>
            <br />
            <Card
              title={'Datos del Pedido N° ' + pedido.numero}
              style={{ width: 500, marginLeft: '25%' }}
            >
              <h3> Organismo: {pedido.organismo.nombre} </h3>
              <h4> Tasas Solicitadas: </h4>
              {_.map(pedido.detalle, det => (
                <p key={det.tipo_sello._id}>
                  {det.tipo_sello.nombre}: {det.cantidad} unidades.
                </p>
              ))}
            </Card>
          </div>
        )}
        <br />
        <FormCrearIngreso opcionRender={1} onSubmit={this.onSubmit} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsPedido: bindActionCreators(actionsPedido, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  // console.log('mapStateToPorps: ', state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(CrearIngreso));
